/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cn } from '@lib/utils';

function InputError({
  className,
  size = 'sm',
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root> & { size?: 'sm' | 'xs' }) {
  return (
    <LabelPrimitive.Root
      className={cn(
        'flex items-center text-[11px] mt-1.5 leading-none text-red-500 select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className
      )}
      data-slot="label"
      {...props}
    />
  );
}

export { InputError };
